import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useTranslation } from 'src/hooks/translations';

import Icon from '../../Icon';
import HiddenFileInput from './HiddenFileInput';
import css from './MediaUploaderSimple.module.scss';
import { _validateImage, _validateVideo } from './helpers';
import { useMediaUpload } from './use-media-upload';

interface Props {
  name: string;
  type: 'images' | 'videos';
  value?: string | ArrayBuffer | null | undefined;
  userId: string;
  label: string;
  onChange?: (e: React.ChangeEvent<any>) => void;
  onUploadComplete: (url: string, fileName: string) => void;
  className?: string;
}

const MediaUploaderSimple: React.FC<Props> = props => {
  const { className = '', name, type, userId, label, onUploadComplete } = props;
  const { translate } = useTranslation('errors');
  const [, meta, helpers] = useField(name);
  const isErrorVisible = meta.touched && !!meta.error;
  const errorText = `העלאה נכשלה`;

  const { uploadFile, uploadProgress, isLoading } = useMediaUpload({
    type,
    onUploadComplete: (url, gcpTempPath, fileName) => {
      helpers.setValue(gcpTempPath);
      helpers.setError('');

      onUploadComplete(url, fileName);
    },
    onError: error => {
      helpers.setError(error);
    },
  });

  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    helpers.setTouched(true);
    helpers.setValue('');
    helpers.setError('');

    await uploadFile(file);
  };

  return (
    <>
      <div className={classNames(css.mediaField, className, isErrorVisible && css.error)}>
        <label>
          <div className={css.btnWrapper}>
            <div className={css.btn}>
              <span>{label}</span>
              <Icon type="plus" color="white" />
              <div className={css.progress} style={{ width: `${uploadProgress}%` }}></div>
            </div>
          </div>
          <HiddenFileInput name={name} type={type} onChange={onFileChange} disabled={isLoading} />
          {isErrorVisible && !isLoading && <p className={css.errorMsg}>{meta.error}</p>}
        </label>
      </div>
    </>
  );
};

export default MediaUploaderSimple;
